<template>
  <div>
    <div>
      <div class="print-footer-info">
        <h3 class="bold f-14">Terms of Apparel Product Purchase Order</h3>
        <p class="f-12 m-b-12"><span class="bold">1.Ownership and Transfer of Risk：</span>Unless otherwise specified in this agreement , The Supplier shall bear the risk of damage and loss of the products (including fabrics, accessories, semi-finished products and finished products, etc.) before delivery.The ownership of the products and the risk of damage and loss shall be transferred to SIXTY after SIXTY receives the products and issues a written receipt certificate after inspection and confirmation.</p>
        <p class="bold f-12">2.Quality and Inspection： </p>
        <p class="f-12"><span class="bold">-Production Specifications: </span>The products shall strictly be manufactured and delivered adhere to the sample garments confirmed by SIXTY and the agreed specific technical standards (including color, size, and proportions). Under no circumstances shall the Supplier alter the production process without obtaining prior written consent from SIXTY.</p>
        <p class="f-12"><span class="bold">-Size Specifications: </span>The products shall strictly be manufactured in accordance with the technical size specifications and pre-production sample measurements confirmed by SIXTY. If deviations exceed the mutually agreed allowable tolerance, SIXTY shall have the legal right to reject and return the products, and all related liabilities and costs shall be solely borne by the Supplier.</p>
        <p class="f-12"><span class="bold">-Product Inspection Requirements: </span>The quality of products shall comply with the laws and regulations of the countries/regions where SIXTY and the Supplier are separately incorporated in, as well as industry standards and requirements. Product quality shall strictly meet qualified requirements of the product test reports and testing reports issued by accredited institutions designated by SIXTY and standards specified by SIXTY.</p>
        <p class="f-12 m-b-12"><span class="bold">Post-Delivery Inspection at Warehouse:</span>Upon delivery of the products to SIXTY’s warehouse, SIXTY has the right to conduct random inspections. In case of any discrepancy in quantity, the quantity actually received by SIXTY shall prevail. If there is short delivery, the Supplier shall be responsible for making up the shortage within the time limit specified by SIXTY and shall bear liability in accordance with clause 5 of this order. If there are quality problems to the products received, SIXTY shall have the right to return the products and require the supplier to indemnify SIXTY the corresponding losses or costs.</p>
        <p class="f-12 m-b-12"><span class="bold">3.Acceptable Delivery Quantity Tolerance: </span>A tolerance of ±5% applies. If the quantity delivered by the Supplier falls within this range, SIXTY shall settle payment based on the actual quantity of qualified products delivered and the agreed unit price.</p>
        <p class="f-12 m-b-12"><span class="bold">4.Compliance: </span>The Supplier shall comply with all laws, regulations, and policies (including but not limited to environmental protection, workplace safety, anti-child labor, labor rights, data security, anti-money laundering, anti-commercial bribery and tax obligations) applicable from time to time in both parties’ jurisdictions. If the Supplier violates the aforesaid requirements or obligations and causes any loss to SIXTY, the Supplier shall indemnify SIXTY and bear related legal liabilities.</p>
        <p class="f-12 m-b-12"><span class="bold">5.Late delivery: </span>If The Supplier fails to deliver the Products before the date of delivery required, the supplier shall pay the penalty for late delivery at 15% of the total amount of the purchase order and the air freight of the products. In case of delayed delivery, SIXTY shall have the right to cancel the order and request the Supplier to return double the deposit of the order and bear the losses caused to SIXTY. If SIXTY chooses to continue to perform this order, the Supplier shall complete the delivery within the time limit specified by SIXTY and pay the penalty for delay in delivery according to the aforesaid amount.</p>
        <p class="f-12 m-b-12"><span class="bold">6.Intellectual Property: </span>Without the written consent of SIXTY, neither the Supplier nor the Supplier's affiliates shall directly or indirectly, in part or in whole, use or license any third parties to use the same or similar logos as "MISS SIXTY", "M60", "ENERGIE", "Killah" in any production or sales activities. If the fabrics, accessories, buttons, zippers, beads, accessories, patterns, etc. used on the products are designed or provided by the Supplier, the Supplier shall ensure that there is no counterfeiting, counterfeiting, etc. that infringes the legitimate rights and interests of any third party, including intellectual property rights.</p>
        <p class="f-12 m-b-12"><span class="bold">7. Governing Law: </span>This order/agreement shall be governed by, construed, and enforced in accordance with the laws of the laws of Italy. Any dispute, controversy, difference or claim arising out of or relating to this order/agreement, including the existence, validity, interpretation, performance, breach or termination arising out of or relating to it be referred to and finally resolved to the to the Milan Arbitration Association (CAM) for arbitration in Milan, Italy in accordance with its arbitration rules then in force. The language of arbitration shall be Italian.</p>
      </div>
      <div class="print-footer">
        <div>
          <div>Buyer: <span class="bold">SIXTY DISTRIBUTION SRL</span> </div>
          <div>Signed by authorized representative <span class="sign">&nbsp;</span></div>
        </div>
        <div>
          <div><span class="bold">Supplier：{{info.vendorName}}</span></div>
          <div>Signed by authorized representative <span class="sign">&nbsp;</span> </div>
        </div>
      </div>
    </div>
    <!-- <div class="print-footer-page">
      <div>{{info.printDate}}</div>
      <div>{{`共 ${totalPage} 页,  第${currentPage}页`}}</div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: "print-footer",
    props: {
      info: {
        type: Object,
        default: () => {
        }
      },
      currentPage: {
        type: Number | String,
        default: ''
      },
      totalPage: {
        type: Number | String,
        default: ''
      }
    },
    computed: {
      footerStyle() {
        return {
          'display': `grid`,
          'grid-template-columns': `1fr`,
          'grid-auto-flow': 'column',
          'grid-template-rows': `repeat(5, auto)`,
          'grid-column-gap': 0,
          'grid-row-gap': 0,
          'margin': `12px 0`,
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .print-footer-info > div {
    text-indent: 2em;
    word-break: break-word;
    font-size: 12px;
    line-height: 24px;
    font-family: SimSun;
  }

  .print-footer-page {
    display: flex;
    justify-content: center;
    gap: 22px;
    font-size: 12px;
    line-height: 24px;
    font-family: SimSun;
  }
  .bold {
    font-weight: bold !important;
  }
  .m-b-12 {
    margin-bottom: 12px;
  }
  .f-14 {
    font-size: 14px;
  }
  .f-12 {
    font-size: 12px;
  }
  .underline {
    text-decoration: underline;
  }
  .print-footer {
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    font-size: 12px;
    font-family: SimSun;
  }
  .print-footer > div:nth-child(1) {
    margin-right: 100px;
  } 
  .print-footer > div div {
    margin-bottom: 10px;
  }
  .sign {
    display: inline-block;
    width: 100px;
    border-bottom: 1px solid;
  }
</style>